import Inspector from './inspector';
const { serverSideRender: ServerSideRender } = wp;

export default ({ attributes, setAttributes }) => {
  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <ServerSideRender block="form-hero/block" attributes={attributes} />
    </>
  );
};
